import React from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';
import SEO from '../components/SEO';
import { C } from '../theme';

const Privacy: React.FC = () => {
  return (
    <>
      <SEO
        title="Politika Privatnosti"
        description="Politika privatnosti Nađi Investitora platforme. Informacije o prikupljanju, korišćenju i zaštiti vaših podataka."
        keywords="privacy policy, politika privatnosti, zaštita podataka, nadji investitora"
        url="/privacy"
      />
      <Box sx={{ pt: '110px', pb: 8, backgroundColor: C.bg, minHeight: '100vh' }}>
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography variant="h2" sx={{ fontWeight: 800, mb: 2, color: C.white }}>
              Politika privatnosti
            </Typography>
            <Typography variant="h6" sx={{ color: C.muted, fontWeight: 400 }}>
              Privacy Policy
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, md: 5 },
              backgroundColor: C.surface,
              borderRadius: 4,
              border: `1px solid ${C.line}`,
            }}
          >
            <Typography variant="h5" sx={{ mt: 0, mb: 2, fontWeight: 600 }}>
              Prikupljanje podataka
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Platforma prikuplja ime i email adresu, informacije o nalogu, sadržaj koji
              korisnik objavljuje i informacije o pretplati.
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
              Korišćenje podataka
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Podaci se koriste isključivo za rad platforme, komunikaciju između korisnika,
              naplatu pretplate i tehničku i korisničku podršku.
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
              Deljenje podataka
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Platforma ne prodaje podatke, ne deli podatke sa trećim licima i koristi podatke
              isključivo unutar sopstvenog sistema.
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
              Bezbednost
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Platforma primenjuje odgovarajuće tehničke i organizacione mere kako bi zaštitila
              lične podatke od neovlašćenog pristupa, gubitka, zloupotrebe, izmene ili otkrivanja.
              Pristup podacima je ograničen samo na ovlašćeno osoblje, a bezbednosne prakse se
              redovno preispituju i ažuriraju po potrebi.
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
              Prava korisnika
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Korisnik ima pravo da pristupi svojim podacima, zatraži njihovu ispravku, obriše
              svoj nalog i ograniči obradu podataka.
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
              Kontakt
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
              Za sva pitanja u vezi sa ovom politikom privatnosti, možete nas kontaktirati:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                Email: info@nadjiinvestitora.com
              </Typography>
              <Typography component="li" variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                Website: www.nadjiinvestitora.com
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default Privacy;
